const LEGACY_BROKEN_VIDEO_PATTERNS = [
  /^https?:\/\/cdn\.pearlvoyages\.com\/home-page\/video\.mp4(?:[?#].*)?$/i,
  /^\/\/cdn\.pearlvoyages\.com\/home-page\/video\.mp4(?:[?#].*)?$/i,
];

const HOMEPAGE_VIDEO_OVERRIDE = String(import.meta.env.VITE_HOMEPAGE_VIDEO_URL || "").trim();

export default function resolveMediaUrl(input) {
  if (!input) return "";
  const value = String(input).trim();

  if (!value) return "";

  const isLegacyBrokenVideo = LEGACY_BROKEN_VIDEO_PATTERNS.some((pattern) => pattern.test(value));
  if (isLegacyBrokenVideo) {
    return HOMEPAGE_VIDEO_OVERRIDE || value;
  }

  return value;
}
